import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-number-two-icon',
  templateUrl: './number-two-icon.component.html',
  styles: []
})
export class NumberTwoIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
